// 상단 이미지 3개 , 체크박스(질문relative, 체크박스 absolute), form, 신청하기, 푸터
// 질문 한페이지에서 2개
// questionContainer="1" (질문relative, 체크박스 absolute)
// questionContainer 없으면 (질문, 체크박스 그냥 밑으로 나열)
// qOptionColor="red"
// formFieldColor="white" (이름&번호 input 배경 흰색)

import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import {
  options,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import PrivacyContent from "./PrivacyContent";

function RandingStyle6({
  urlCode,
  urlCodeSettingId,
  img1Path,
  img2Path,
  img3Path,
  img4Path,
  formFieldColor,
  questionContainer,
  qOptions,
  qOptionColor,
  questionType,
  postBTN,
  companyName,
  privacyCompanyName,
  footerPath,
  privacyMessage,
  // 랜딩 별로 태그 설정인 경우

  addClass,
  apiUrl,
  kakaotalk,
  carrotTag,
}) {
  const navigate = useNavigate();
  // 상태 관리
  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (option) => {
    setSelectedOption(option);
    console.log(option);
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      kakaotalk,
      carrotTag,
    });
  };

  return (
    <form
      className="form-container"
      onSubmit={(e) => {
        e.preventDefault(); // 기본 제출 동작 방지
        handleSubmit(); // 기존 handleSubmit 호출
      }}
    >
      <div className="step1">
        {img1Path && <img src={img1Path} />}
        {img2Path && <img src={img2Path} />}
        {img4Path && <img src={img4Path} />}
        <div className="qBox">
          <div
            className={`questionContainer ${
              questionContainer == 1 ? "rel" : ""
            }`}
          >
            <img src={img3Path} />
            <div
              className={`qOptions row ${
                questionContainer == 1 ? "absol" : ""
              }`}
            >
              {(qOptions || options).map((option, index) => (
                <img
                  key={index}
                  src={`${process.env.REACT_APP_CDN_BASE}/images/qOptions/${
                    questionType || "checkBox"
                  }/${
                    selectedOption === option
                      ? `${qOptionColor || "red"}/qoption${index + 1}(1)`
                      : `qoption${index + 1}`
                  }.${
                    (questionType || "checkBox") === "btn" ||
                    (questionType || "checkBox") === "checkBox"
                      ? "jpg"
                      : "png"
                  }`}
                  alt={option}
                  onClick={() => handleSelectImplant(option)}
                />
              ))}
            </div>
          </div>
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          <div className="formBox">
            <div
              className={`formField ${
                formFieldColor === "white" ? "white" : ""
              }`}
            >
              <label htmlFor="name">이름</label>
              <input
                type="text"
                id="name"
                maxLength="10"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <PhoneNumberInput
              phoneNumber={phoneNumber}
              phoneFirstOptions={phoneFirstOptions}
              handlePhoneNumberChange={handlePhoneNumberChange}
              formFieldColor={formFieldColor}
            />
            <PrivacyPolicyAgree
              isAgreed={isAgreed}
              setIsAgreed={setIsAgreed}
              togglePrivacyPolicyModal={togglePrivacyPolicyModal}
              privacyMessage={privacyMessage}
            />
          </div>
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          <p className="benefitInfo">
            <BenefitPeriod />
            <br />
            이벤트 대상자 : 해당 매체 이용자
          </p>
        </div>
        {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
        {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
        {isPrivacyPolicyModal && (
          <div className="modalOverlay" onClick={togglePrivacyPolicyModal}>
            <div
              className="privacyPolicyContent"
              onClick={(e) => e.stopPropagation()}
            >
              <PrivacyContent companyName={privacyCompanyName || companyName || "수집주체명"} />
            </div>
          </div>
        )}
        <button type="submit" className="sendBtnBox" disabled={isSubmitting}>
          <img src={postBTN} alt="신청하기" />
        </button>
      </div>

      <div className="footer">
        {footerPath && <img src={footerPath} alt="푸터" />}{" "}
      </div>
    </form>
  );
}

export default RandingStyle6;
